import { HighlightSectionSkeletonContent } from './components/highlight-section-skeleton-content';

export { HighlightSectionHeader } from './components/highlight-section-header';
export { HighlightSectionSkeletonCards } from './components/highlight-section-skeleton-cards';

export const EventReportHighlightSectionSkeleton = ({ title, subtitle }: { title: string; subtitle?: string }) => {
  return (
    <section className='mb-14 md:mb-20'>
      <HighlightSectionSkeletonContent title={title} subtitle={subtitle} />
    </section>
  );
};
